import './Subiecte.css';

export default function Subiecte2013() {
    return (
        <div className="container my-4">
            <h2 className="fw-bold mb-4 subjectTitle">{'<'}Subiecte 2013{'/>'}</h2>
            <div className="mb-4">
                <h5>1. <strong>August</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2013/SubiectAugust2013MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a></li>
                            <li><a href="/subiecte/2013/BaremAugust2013MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2013/SubiectAugust2013SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a></li>
                            <li><a href="/subiecte/2013/BaremAugust2013SN.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>2. <strong>Iunie</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2013/SubiectIunie2013MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a></li>
                            <li><a href="/subiecte/2013/BaremIunie2013MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2013/SubiectIunie2013SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a></li>
                            <li><a href="/subiecte/2013/BaremIunie2013SN.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>3. <strong>Sesiunea Specială</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2013/SubiectSpeciala2013MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a></li>
                            <li><a href="/subiecte/2013/BaremSpeciala2013MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>4. <strong>Simulare</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2013/SubiectSimulare2013MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a></li>
                            <li><a href="/subiecte/2013/BaremSimulare2013MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>5. <strong>Model</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2013/SubiectModel2013MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a></li>
                            <li><a href="/subiecte/2013/BaremModel2013MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2013/SubiectModel2013SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a></li>
                            <li><a href="/subiecte/2013/BaremModel2013SN.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    );
}